import { render } from "./PlatFormLevel.vue?vue&type=template&id=1b9779e8&scoped=true"
import script from "./PlatFormLevel.vue?vue&type=script&lang=js"
export * from "./PlatFormLevel.vue?vue&type=script&lang=js"

import "./PlatFormLevel.vue?vue&type=style&index=0&id=1b9779e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9779e8"]])

export default __exports__